import { render, staticRenderFns } from "./AccUpdatePersonalDataPopup.vue?vue&type=template&id=10bed950&"
import script from "./AccUpdatePersonalDataPopup.vue?vue&type=script&lang=js&"
export * from "./AccUpdatePersonalDataPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports